import React, { useMemo } from "react";
import BarChart from "components/charts/BarChart";

const CAByCategoryChart = ({ years, categoryTotalsByYear }) => {
  // years: number[]
  // categoryTotalsByYear: Record<year, Record<category, amount>>
  const { chartSeries, chartOptions } = useMemo(() => {
    const categoriesSet = new Set();
    years.forEach((year) => {
      const totalsForYear = categoryTotalsByYear[year] || {};
      Object.keys(totalsForYear).forEach((cat) => categoriesSet.add(cat));
    });

    const categories = Array.from(categoriesSet);

    const series = categories.map((categoryName) => ({
      name: categoryName,
      data: years.map((year) => {
        const totalsForYear = categoryTotalsByYear[year] || {};
        return Number(totalsForYear[categoryName] || 0);
      }),
    }));

    const options = {
      chart: { type: "bar", stacked: true, toolbar: { show: false } },
      xaxis: {
        categories: years,
        title: { text: "Année" },
        labels: { style: { fontSize: "12px" } },
      },
      yaxis: {
        title: { text: "Montant HT (DH)" },
        labels: {
          formatter: (v) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v),
        },
      },
      plotOptions: {
        bar: { horizontal: false, columnWidth: "55%", borderRadius: 4 },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH",
        style: { fontSize: "12px", fontWeight: "bold", colors: ["#000000"] },
        background: {
          enabled: true,
          borderRadius: 6,
          borderWidth: 0,
          opacity: 0.85,
          dropShadow: { enabled: false },
        },
      },
      tooltip: {
        theme: 'dark',
        y: {
          formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH",
        },
      },
      legend: { position: "top", horizontalAlign: "right" },
      colors: [
        "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd",
        "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf",
      ],
      grid: { strokeDashArray: 4 },
    };

    return { chartSeries: series, chartOptions: options };
  }, [years, categoryTotalsByYear]);

  return (
    <BarChart chartData={chartSeries} chartOptions={chartOptions} width="100%" height={520} />
  );
};

export default CAByCategoryChart;
